// extracted by mini-css-extract-plugin
export var cardIcon = "_b1-4";
export var checkboxCard = "_b1-0";
export var checkboxCardSelected = "_b1-3";
export var disabled = "_b1-1";
export var outerBorder = "_b1-2";
export var spacerMedium = "_b1-7";
export var spacerSmall = "_b1-6";
export var spacerXsmall = "_b1-5";